// @flow
import range from 'lodash/range';
import React, { Fragment } from 'react';

import DaySelector from './DaySelector';


type WeekSchedulePropTypes = {
  value?: Array<number>,
  onChange?: Function,
  conflictedWeekDays?: Array<number>,
  disabledWeekDays?: Array<number>,
};

const WeekSchedule = ({
  value = [],
  onChange,
  disabledWeekDays = [],
  conflictedWeekDays = [],
}: WeekSchedulePropTypes) => (
  <Fragment>
    {
      range(7).map((day) => {
        const isConflicted = conflictedWeekDays.includes(day);
        const dayValue = value.includes(day);
        return (
          <DaySelector
            key={day}
            value={dayValue}
            disabled={disabledWeekDays.includes(day)}
            isConflicted={isConflicted}
            onChange={(lDayValue) => {
              const lValue = value.filter(lDay => !disabledWeekDays.includes(lDay));
              if (onChange) {
                if (isConflicted) {
                  onChange([...lValue], true, day);
                } else if (lDayValue) {
                  if (!value.includes(day)) {
                    onChange([...lValue, day], true, day);
                  }
                } else {
                  onChange(value.filter(lDay => lDay !== day), false, day);
                }
              }
            }}
          />
        );
      })
    }
  </Fragment>
);


export default WeekSchedule;



// WEBPACK FOOTER //
// ./src/scripts/components/WeekSchedule/index.jsx